// PDP shell: navigation is owned by edvi-header.js; cart by edvi-owned-bag.js.
// Only the shared search dialog and scroll progress need theme-level handlers here.
(() => {
  const search = document.querySelector('[data-search-dialog]');
  document.querySelectorAll('[data-open-search]').forEach(button => {
    button.addEventListener('click', () => {
      search?.showModal();
      search?.querySelector('input[type="search"]')?.focus();
    });
  });
  document.querySelectorAll('[data-close-search]').forEach(button => {
    button.addEventListener('click', () => search?.close());
  });
  search?.addEventListener('click', event => {
    if (event.target === search) search.close();
  });
  let frame;
  addEventListener('scroll', () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      const maximum = document.documentElement.scrollHeight - innerHeight;
      document.documentElement.style.setProperty('--scroll-progress', maximum > 0 ? scrollY / maximum : 0);
      frame = null;
    });
  }, {passive:true});
})();
